import { useTranslation } from 'react-i18next';
import AccountTerminationModalBase from '@/components/ModalRenderer/components/components/AccountTerminationModalBase';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { formatDate } from '@/utils/date';

type Props = ModalProps<{ idProtectValidThrough: string }>;

const LoanIdProtectTermination = ({ payload: { idProtectValidThrough } }: Props) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'LoanIdProtectTermination' });

  return (
    <AccountTerminationModalBase title={t('title')} buttonText={t('button')}>
      <p>
        {t('info1', {
          dateValidThrough: formatDate(new Date(idProtectValidThrough)),
        })}
      </p>
      <p>{t('info2')}</p>
      <p>{t('feedbackInfo')}</p>
    </AccountTerminationModalBase>
  );
};

export default LoanIdProtectTermination;
